import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import { listaTipoPrecos } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';

export class ItinerarioEncomenda extends React.Component {

    categoriasItinerario(itinerario) {
        const poltronas = itinerario.poltronas;
        const tipoPrecos = [...new Set(poltronas.map(it => it.tipoPreco))];
        let tipos = '';
        tipoPrecos.forEach((it, index) => {
            const item = listaTipoPrecos.filter(l => l.id == it);
            if (item && item.length > 0) {
                tipos += `${index > 0 ? ' | ' : ''} ${item[0].descricao}`
            }
        })
        return tipos
    }

    exibirCategorias(itinerario) {
        if (itinerario.tipoPreco) {
            return itinerario.tipoPreco.descricaoTipoPreco;
        }
        const tooltipId = `categoria-${itinerario.id}`;
        return (
            <>
                {itinerario.tipoCategoria}
                <span style={{ marginLeft: 4, display: 'inline-flex', alignItems: 'center' }}>
                    <a data-tip data-for={tooltipId}>
                        <span className="material-icons" style={{ fontSize: 15, color: '#aaa', cursor: 'pointer' }}>info</span>
                    </a>
                    <ReactTooltip id={tooltipId} type="dark" effect="solid">
                        <span>{this.categoriasItinerario(itinerario)}</span>
                    </ReactTooltip>
                </span>
            </>
        );
    }

    render() {
        const it = this.props.itinerario;
        return (
            <div className="vx-row-item">
                <div className="vx-row-item-inner vx-row-item-inner--itin-encomenda">
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data/Hora saída</span>
                        <Moment format="DD/MM/YYYY">{it.dataPartida}</Moment> às {it.horaSaida}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Assentos</span>
                        {it.assentosDisponiveis}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Veículo</span>
                        {it.veiculoDto.descricao}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Rota</span>
                        {it.rotaDto.cidadeOrigem.nome}-{it.rotaDto.cidadeOrigem.uf} &rarr; {it.rotaDto.cidadeDestino.nome}-{it.rotaDto.cidadeDestino.uf}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Prestador</span>
                        {it.prestador ? it.prestador.valor : 'Frota própria'}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Venda Site</span>
                        <span className={`vx-row-badge${it.habilitadoSite ? ' vx-row-badge--ok' : ''}`}>
                            {it.habilitadoSite ? 'Ativo' : 'Inativo'}
                        </span>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Categorias</span>
                        {this.exibirCategorias(it)}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Status</span>
                        <span className={`vx-row-badge${it.ativo ? ' vx-row-badge--ok' : ''}`}>
                            {it.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Ações</span>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getAdminEmpresa(this.props.empresaSelecionada.id),
                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getMotoristaEmpresa(this.props.empresaSelecionada.id),
                            getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                            empresaSelecionada={this.props.empresaSelecionada}>
                            <button type="button" className="vx-bag-btn vx-bag-btn--receipt"
                                title="Ver encomendas do itinerário"
                                onClick={() => this.props.history.push(`/painel-gerenciar-encomendas-itinerario?itinerario=${it.id}`)}>
                                <span className="material-icons" style={{ fontSize: 15 }}>search</span>
                                Ver encomendas
                            </button>
                        </Autorizacao>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
    }
}

export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    selecionarItinerario,
    buscarReservasItinerario,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
})(reduxForm({
    form: 'formularioItinerario'
})(ItinerarioEncomenda)))
